// extracted by mini-css-extract-plugin
export default {"button":"ButtonNoHtmlatt-module__button___WS+8H","active":"ButtonNoHtmlatt-module__active___aheGj"};